<template>
    <div>
        <swb-bid-doc-search class="mt10" @showSearch="showSearch"></swb-bid-doc-search>

        <div class="tab-container small base mt10 mb10">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="(text, value) in bidDocStateList" :class="{'current': value == checkStateValue}" class="head-item" @click="tabChange(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>

        <div>
            <table class="custom-tbl" v-if="checkStateValue==0">
                <thead class="head">
                <tr class="row align-left">
                    <th width="180" style="text-align: left">投标编号</th>
                    <th width="" style="text-align: left">招标标题</th>
                    <th width="200" style="text-align: left">招标方</th>
                    <th width="140">投标开始时间</th>
                    <th width="140">投标截至时间</th>
                    <th width="200" style="text-align: left">报名人</th>
                    <th width="80">状态</th>
                    <th width="250" style="text-align: left">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row align-left" v-for="bidDoc in bidDocList">
                    <td>{{bidDoc.no}}</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(bidDoc.callDocId,bidDoc.openTime)">{{bidDoc.title}}</a>
                    </td>
                    <td style="text-align: left">{{bidDoc.fstPartyName}}</td>
                    <td>{{bidDoc.openTime}}</td>
                    <td>{{bidDoc.closeTime}}</td>
                    <td style="text-align: left">{{bidDoc.applicantName}}</td>
                    <td>
                        <span v-if="bidDoc.applyState==0">未申请</span>
                        <span v-if="bidDoc.applyState==1 && bidDoc.auditState==0">待审核</span>
                        <span v-if="bidDoc.auditState==1">通过</span>
                        <span v-if="bidDoc.auditState==-1">未通过</span>
                    </td>

                    <td style="text-align: left">
                        <!-- 未审核/审核未通过 -->
                        <a class="swb-btn-link" v-if="bidDoc.applyState == 0 && checkActionPerm('apply')" @click="bidDocApply(bidDoc.id)">申请</a>
                        <a class="swb-btn-link" v-if="bidDoc.applyState == 2 && bidDoc.auditState==-1 && checkActionPerm('next_apply')" @click="bidDocApply(bidDoc.id)">再次申请</a>
                        <a class="swb-btn-link" v-if="bidDoc.applyState != 1 && bidDoc.auditState != 1 && checkActionPerm('modify')" @click="toSaveBidDoc(bidDoc.id,bidDoc.callDocId)">修改</a>
                        <a class="swb-btn-link" v-if="bidDoc.applyState == 1 && bidDoc.auditorPostId == postId && checkActionPerm('audit')" @click="bidDocAudit(bidDoc.id,bidDoc.callDocId)">审核</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(bidDoc.callDocId)"> 查看招标书公告</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toBidDocInfo(bidDoc.id)">查看投标书详情</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_audit_rec')" @click="getbidDocAuditRecs(bidDoc.id)">审核记录</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="getBidActRecList(bidDoc.id)">操作记录</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==1">
                <thead class="head">
                <tr class="row align-left">
                    <th width="180" style="text-align: left">投标编号</th>
                    <th width="" style="text-align: left">招标标题</th>
                    <th width="200" style="text-align: left">招标方</th>
                    <th width="140">投标结束时间</th>
                    <th width="140">开标时间</th>
                    <th width="165">投标时间</th>
                    <th width="200" style="text-align: left">投标人</th>
                    <th width="250" style="text-align: left">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row align-left" v-for="bidDoc in bidDocList">
                    <td>{{bidDoc.no}}</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(bidDoc.callDocId,bidDoc.openTime)">{{bidDoc.title}}</a>
                    </td>
                    <td style="text-align: left">{{bidDoc.fstPartyName}}</td>
                    <td>{{bidDoc.closeTime}}</td>
                    <td>{{bidDoc.resultPublishTime}}</td>
                    <td>{{bidDoc.bidTime}}</td>
                    <td style="text-align: left">{{bidDoc.applicantName}}</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(bidDoc.callDocId)"> 查看招标书公告</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toBidDocInfo(bidDoc.id)">查看投标书详情</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="getBidActRecList(bidDoc.id)">操作记录</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==2">
                <thead class="head">
                <tr class="row align-left">
                    <th width="180" style="text-align: left">投标编号</th>
                    <th width="" style="text-align: left">招标标题</th>
                    <th width="200" style="text-align: left">招标方</th>
                    <th width="200" style="text-align: left">招标联系人</th>
                    <th width="110">电话</th>
                    <th width="140">开标时间</th>
                    <th width="250" style="text-align: left">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row align-left" v-for="bidDoc in bidDocList">
                    <td>{{bidDoc.no}}</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(bidDoc.callDocId,bidDoc.openTime)">{{bidDoc.title}}</a>
                    </td>
                    <td style="text-align: left">{{bidDoc.fstPartyName}}</td>
                    <td style="text-align: left">{{bidDoc.callContactName}}</td>
                    <td>{{bidDoc.callContactTel}}</td>
                    <td>{{bidDoc.resultPublishTime}}</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(bidDoc.callDocId)"> 查看招标书公告</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toBidDocInfo(bidDoc.id)">查看投标书详情</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="getBidActRecList(bidDoc.id)">操作记录</a>
                    </td>
                </tr>
                </tbody>
            </table>

            <table class="custom-tbl" v-if="checkStateValue==3">
                <thead class="head">
                <tr class="row align-left">
                    <th width="180" style="text-align: left">投标编号</th>
                    <th width="" style="text-align: left">招标标题</th>
                    <th width="200" style="text-align: left">招标方</th>
                    <th width="140">开标时间</th>
                    <th width="200" style="text-align: left">投标人</th>
                    <th width="140">投标时间</th>
                    <th width="250" style="text-align: left">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row align-left" v-for="bidDoc in bidDocList">
                    <td>{{bidDoc.no}}</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(bidDoc.callDocId,bidDoc.openTime)">{{bidDoc.title}}</a>
                    </td>
                    <td style="text-align: left">{{bidDoc.fstPartyName}}</td>
                    <td>{{bidDoc.resultPublishTime}}</td>
                    <td style="text-align: left">{{bidDoc.applicantName}}</td>
                    <td>{{bidDoc.bidTime}}</td>
                    <td style="text-align: left">
                        <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="getCallBidNoticeByCallBidDocId(bidDoc.callDocId)"> 查看招标书公告</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toBidDocInfo(bidDoc.id)">查看投标书详情</a>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_rec')" @click="getBidActRecList(bidDoc.id)">操作记录</a>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils} from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import userApi from '../../api/user'
    import tendBidApi from '../../api/tendBid'

    import { getDefaultPageSizes } from '../../app.conf';
    import { showComAuditorSelectDlg } from '../merchant/showSelectDlg'

    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'

    import { checkUserActionPerm } from '../index'

    import SwbBidDocInfo from './BidDocInfo';
    Routes.add(SwbBidDocInfo);

    import SwbCallBidDocInfo from './CallBidDocInfo';
    Routes.add(SwbCallBidDocInfo);

    import SwbSaveBidDoc from './SaveBidDoc';
    Routes.add(SwbSaveBidDoc);

    import SwbCallBidNoticeList from './CallBidNoticeList';
    Vue.regist(SwbCallBidNoticeList);

    import SwbBidEnrollAuditRecList from './BidEnrollAuditRecList';
    Vue.regist(SwbBidEnrollAuditRecList);

    import SwbBidDocAudit from './BidDocAudit';
    Vue.regist(SwbBidDocAudit);

    import SwbCallBidApply from './CallBidApply';
    Vue.regist(SwbCallBidApply);

    import SwbBidDocSearchLet from './BidDocSearchLet'
    Vue.regist(SwbBidDocSearchLet);

    import SwbBidActRecList from './BidActRecList';
    Vue.regist(SwbBidActRecList);

    export default{
        name: 'swb-bid-doc-list',
        path: '/tend/bid/doc/list',
        pathOld: '/servc/bid/doc/list',
        avlActions: 'apply|next_apply|modify|audit|view_notice|view|view_audit_rec|view_rec',
        avlActionNames: '审核、查看招标书公告、查看投标书详情、审核记录、再次申请、修改、申请',
        avlScopes: 'servicer',
        desc: '投标书列表',
        helpArticleCode: 'servicer-tend-bid-doc-list',
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                bidDocList: [],
                bidDocStateList: [],
                postId: null,
                checkStateValue: 0,
                userInfo: null,
                InitialState: null,
            }
        },
        created: function () {
            let self = this;
            //
            self.pageSize = self.pageSizes.first();
            //----------------------查询------------------------------
            self.getCurrentUserInfo();
            //
            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.queryModel.filterItems.no = no;
                this.searchShow = true;
            }
            //
            let checkState = this.$route.query.checkState || null;
            if(checkState != null) {
                this.getBidDocList(checkState);
            } else {
                this.getBidDocList(0);
            }
            // 过滤条件 枚举
            self.bidDocStateList = getEnumMap('bidDocState', 'value2text');
        },
        methods: {
            showSearch: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getBidDocList(this.checkStateValue);
            },

            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getBidDocList(val);
            },
            handleSizeChange: function (val) {
                let curStartIndex = this.pageNumber * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBidDocList(this.checkStateValue);
            },

            searchTag: function (tag) {
                this.sndPartyFlag = tag;
                this.searchShow = true;
                this.getBidMarketList(this.checkStateValue);
            },

            getCurrentUserInfo: function () {   // 当前登录信息
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        self.postId = userInfo.scopeEntity.postId;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getBidDocList: function (value) {
                let self = this;

                self.checkStateValue = value;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                // filterItems.bidState = value;
                // if(value != self.InitialState) {
                //     var sortItem = "bidTime" + ":" + "DESC";
                //     if(sortItem != null) {
                //         let sortItemList = [sortItem];
                //         postData.sortItemList = sortItemList;
                //     }
                // }
                //
                filterItems.bidState = value;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                tendBidApi.getBidDocList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.bidDocList = result.data.rows;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getCallBidNoticeByCallBidDocId: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: '公告列表 - 查看',
                    showCloseBtn: true,
                    width: 900,
                    height: 700,
                    template: '<div>' +
                    '<swb-call-bid-notice-list :docId="docId" ref="swb_call_Bid_notice_list"></swb-call-bid-notice-list>' +
                    '</div>',
                    data: {
                        docId: id,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {}

                });
            },

            toBidDocInfo: function (id) {
                this.$router.push({
                    path: SwbBidDocInfo.path,
                    query: {
                        bidDocId: id,
                        checkState: this.checkStateValue
                    }
                });
            },
            toCallBidDocInfo: function (id, openTime) {
                this.$router.push({
                    path: SwbCallBidDocInfo.path,
                    query: {
                        callBidDocId: id,
                        flag: true,
                        checkState: this.checkStateValue,
                        openTime: openTime,
                        hisUrl: '/servc/bid/doc/list',
                    }
                });
            },

            toSaveBidDoc: function (id, callDocId) {
                this.$router.push({
                    path: SwbSaveBidDoc.path,
                    query: {
                        id: id,
                        callBidDocId: callDocId
                    }
                });
            },
            // 申请
            bidDocApply: function (id) {
                let self = this;
                //
                showComActionPostSelectDlg({
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                    //auditorId : null //初始 auditorId
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选 择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: id,
                        //
                        auditorPostId: resultData.postId,
                        //
                        applyDesc: resultData.applyDesc
                    };

                    tendBidApi.applyBidDoc(postData, function (result) {
                        if(result.type == 'info') {
                            MsgBox.success('申请成功');
                            //
                            self.getBidDocList(self.checkStateValue);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },
            bidDocAudit: function (id, callDocId) {
                let self = this;
                showBizAuditDlg({
                    title: "投标 - 审核",
                    nextPostParams: {
                        rescUrl: Vue.$getClassInfo(self).path,
                        action: 'audit',
                    }
                }, function (resultData) {
                    resultData = resultData || {};
                    let nextPostResultData = resultData.nextPostResultData || null;
                    let auditorPostId = null;
                    if(nextPostResultData != null) {
                        auditorPostId = nextPostResultData.postId;
                    }
                    let postData = {
                        id: id,
                        callDocId: callDocId,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                        auditorPostId: auditorPostId,
                    };
                    tendBidApi.auditBidDoc(postData, function (result) {
                        if(result.type == 'info') {
                            self.getBidDocList(self.checkStateValue);
                            MsgBox.success('操作成功');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },
            // 审核记录
            getbidDocAuditRecs: function (id) {
                Vue.$showDialog({
                    title: "审核记录",
                    template: '<div><swb-bid-enroll-audit-rec-list :id="id" :type="bid" ref="swb_bid_enroll_audit_rec_list"></swb-bid-enroll-audit-rec-list>' +
                    '</div>',
                    data: {
                        loading: false,
                        id: id,
                        bid: 'bid'
                    },
                });
            },
            // 操作记录
            getBidActRecList: function (id) {
                Vue.$showDialog({
                    title: '操作记录-查看',
                    showCloseBtn: true,
                    width: 1000,
                    height: 600,
                    template: '<div>' +
                    '<swb-bid-act-rec-list ref="swb_bid_act_rec_list" :docId="docId"></swb-bid-act-rec-list>' +
                    '</div>',
                    data: {
                        docId: id
                    },
                    okVisible: false,
                    method: {},
                });
            },
            lookNotice: function (content) {
                let self = this;
                Vue.$showDialog({
                    title: '查看 - 公告',
                    showCloseBtn: true,
                    width: 1200,
                    height: 900,
                    template: '<div>' +
                    '<swb-ck-editor ref="theCkEditor" :content="content"></swb-ck-editor>' +
                    '</div>',
                    data: {
                        content: null,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {
                        created: function () {
                            this.content = content;
                        }
                    }

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/BidDocList.vue